 // Scripting to handle tabs interaction
(function($){
	$(".tab-content").hide();

	$(".wp-block-columns.tabs .wp-block-cover").click(function () {
	  	$(".tab-content").hide();
	  	var activeTab = $("a", this).attr("href");
		$(activeTab).css('display', 'flex');

	  	$(".wp-block-columns.tabs .wp-block-cover").removeClass("active");
	  	$(this).addClass("active");
	});
	$(".tab-close-button").click(function () {
		$(".tab-content").hide();
		$(".wp-block-columns.tabs .wp-block-cover").removeClass("active");

	});
})(jQuery);
